


















import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';

@Component({
    name: 'Alert',
    components: { }
})
export default class extends Vue {

    get errorMessage(){
        return AppModule.lastError == null? "" : AppModule.lastError.message;
    }

     get errorCode(){
        return AppModule.lastError == null? "" : AppModule.lastError.code;
    }

    get showAlert(){
        return AppModule.lastErrorVisible;
    }

    set showAlert(value){
        if (!value)
            AppModule.clearErrorMessage();
    }

    get showRefreshButton(){
        if (AppModule.lastError != null) {
            return AppModule.lastError.showRefreshButton;
        } else {
            return false;
        }
    }
}

